import { render, staticRenderFns } from "./DashboardRanding.vue?vue&type=template&id=36b20a68&scoped=true"
import script from "./DashboardRanding.vue?vue&type=script&lang=js"
export * from "./DashboardRanding.vue?vue&type=script&lang=js"
import style0 from "./DashboardRanding.vue?vue&type=style&index=0&id=36b20a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b20a68",
  null
  
)

export default component.exports